import { Button, Dialog, DialogPanel } from "@headlessui/react";
import { IoMdClose } from "react-icons/io";
import { useTranslation } from "react-i18next";
import { ApiGet, ApiPost } from "../../helper/axiosFunctions";
import { commonToast } from "../../helper/Toast";
import { useCallback, useEffect, useState } from "react";
import ImageSkeleton from "../skeleton/ImageSkeleton";
import { generateRandomId } from "../../helper/commonFunctions";
import { getSelectedSchoolId } from "../../helper/commonFunctions";

export default function CreateClassmodel({ open, setOpen, getClasses, editMode = false, editingClass = null, onUpdate }) {
  const userData = JSON.parse(localStorage?.getItem("zubrus_user_data"))?.data?.userInfo;
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [formData, setFormData] = useState({
    className: "",
  });

  const resetForm = useCallback(() => {
    setFormData({
      className: "",
    });
    setSelectedImage(null);
  }, []);

  const getClassImages = useCallback(async () => {
    setLoading(true);
    try {
      const response = await ApiGet(`/contents/images`);
      setData(response?.data);
    } catch (error) {
      commonToast(error?.data?.errorDescription || error?.data?.error || error?.message, "error");
    } finally {
      setLoading(false);
    }
  }, []);
  console.log('editingClass :>> ', editingClass, selectedImage);
  useEffect(() => {
    if (open) {
      getClassImages();
      if (editMode && editingClass) {
        setFormData({
          className: editingClass.className,
        });
        setSelectedImage({
          url: editingClass.smallLogoUrl
        });
      }
    } else {
      resetForm();
    }
  }, [getClassImages, open, resetForm, editMode, editingClass]);

  const handleClose = () => {
    resetForm();
    setOpen(false);
  };

  const handleSubmit = async () => {
    if (!formData.className) {
      commonToast("Please enter class name", "error");
      return;
    }

    if (!selectedImage) {
      commonToast("Please select an image", "error");
      return;
    }

    try {
      const payload = {
        ...formData,
        smallLogoUrl: selectedImage?.url,
        largeLogoUrl: selectedImage?.url,
        classId: editMode ? editingClass.classId : generateRandomId(),
        "schoolId": getSelectedSchoolId(),    
        "country": "LT"
      };

      if (editMode) {
        await onUpdate(payload);
      } else {
        const response = await ApiPost('/contents/classes', payload);
        if (response.code === 200) {
          commonToast("Class created successfully", "success");
          getClasses();
        }
      }
      setOpen(false);
    } catch (error) {
      commonToast(error?.data?.errorDescription || error?.data?.error || error?.message, "error");
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        as="div"
        className="relative z-30 focus:outline-none"
        onClose={handleClose}
      >
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 bg-black/35 backdrop-blur-sm">
            <DialogPanel
              transition
              className="w-full relative max-w-md rounded-3xl bg-white duration-300 ease-out data-[closed]:transform-[scale(95%)] data-[closed]:opacity-0"
            >
              <div className="p-6 -mt-14 bg-white relative z-10 rounded-3xl">
                <div className="flex justify-between items-center text-xl font-semibold">
                  <h2>{editMode ? t("editclass") : t("createclass")}</h2>
                  <IoMdClose
                    className="absolute right-5 top-5 cursor-pointer hover:text-gray-600 transition-colors"
                    fontSize={20}
                    onClick={handleClose}
                  />
                </div>
                <input
                  type="text"
                  placeholder={t("name")}
                  value={formData.className}
                  onChange={(e) => setFormData(prev => ({ ...prev, className: e.target.value }))}
                  className="regular-text border h-[56px] my-5 w-full rounded-xl ps-5 shadow-inner outline-none placeholder:text-lightgray text-black focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all"
                />

                <span className="regular-text text-gray-700 block mb-2">{t("picture")}</span>
                <div className="grid grid-cols-6 lg:grid-cols-4 gap-2 mt-2 min-h-[120px]">
                  {loading ? (
                    <ImageSkeleton />
                  ) : (
                    data?.map((item) => (
                      <div
                        key={item?.id}
                        onClick={() => setSelectedImage(item)}
                        className={`rounded-xl flex items-center justify-center p-2 cursor-pointer transition-all ${(selectedImage?.url) === item?.url
                          ? 'border border-blue-500 bg-blue-50 ring-2 ring-blue-200'
                          : 'border border-gray-200 hover:bg-gray-50'
                          }`}
                      >
                        <img
                          src={item?.url}
                          loading="lazy"
                          alt={item?.imageName}
                          className="w-[47px] h-[45px] object-contain object-center"
                        />
                      </div>
                    ))
                  )}
                </div>

                <div className="mt-5">
                  <Button
                    className="primary-btn w-full medium-text"
                    onClick={handleSubmit}
                  >
                    {editMode ? t("updateclass") : t("createclass")}
                  </Button>
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
